<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-datetime ttLabel="timestamp_start" [ttModel]="edit.timestamp_start" ttReadonly></tt-datetime>
        <tt-datetime ttLabel="timestamp_split" [(ttModel)]="edit.timestamp_split"></tt-datetime>
        <tt-datetime ttLabel="timestamp_end" [ttModel]="edit.timestamp_end" ttReadonly></tt-datetime>
        <tt-button-save ttText="timeregistersplit_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
